<div id="scrn-table">
  <div id="scrn-cell">
    <div id="scrn-p">

      <header id="scrn-h">
        <div class="subtitle-strap">
          {{locale.title}}
        </div>
      </header>

      <div id="scrn-c" *ngIf="isDaraUser">
        <h2 class="legend">
          Your account is linked to MyFutureJourney, please do any changes in this account.
        </h2>
      </div>

      <div id="scrn-c" *ngIf="!isDaraUser">
        <div class="columns">
          <form class="column" (submit)="submitProfileForm()">
            <h2 class="legend">
              {{locale.personalDetailsHeaderText}}
            </h2>
            <div class="form-control">
              <label for="firstName">{{locale.firstNamePlaceholder}}</label>
              <input (click)="onClickProfileInput()" id="firstName" type="text" class="input-control" [formControl]="profileForm.controls['firstName']" spellcheck="false"/>
              <div class="validation-error" *ngIf="(profileFormSubmitted || profileForm.controls['firstName'].dirty) && !profileForm.controls['firstName'].valid">
                <div class="form-hint">
                  <div>{{locale.firstNameValidationText}}</div>
                </div>
              </div>
            </div>
            <div class="form-control">
              <label for="lastName">{{locale.lastNamePlaceholder}}</label>
              <input (click)="onClickProfileInput()" id="lastName" type="text" class="input-control" [formControl]="profileForm.controls['secondName']" spellcheck="false"/>
              <div class="validation-error" *ngIf="(profileFormSubmitted || profileForm.controls['secondName'].dirty) && !profileForm.controls['secondName'].valid">
                <div class="form-hint">
                  <div>{{locale.lastNameValidationText}}</div>
                </div>
              </div>
            </div>
            <div class="form-control">
              <label for="email">{{locale.emailPlaceholder}}</label>
              <input (click)="onClickProfileInput()" id="email" type="email" class="input-control" [formControl]="profileForm.controls['email']" spellcheck="false"/>
              <div class="validation-error" *ngIf="(profileFormSubmitted || profileForm.controls['email'].dirty) && !profileForm.controls['email'].valid">
                <div class="form-hint">
                  <div>{{locale.emailValidationText}}</div>
                </div>
              </div>
            </div>

            <div class="form-control">

              <label for="gender">{{locale.genderPlaceholder}}</label>
              <select (click)="onClickProfileInput()" id="gender" class="input-control select-control" [formControl]="profileForm.controls['gender']">
                <option *ngFor="let item of genderOptions | orderBy : 'order' " [value]="item.id">{{item.gender}}</option>
              </select>

              <span class="caret"></span>
              <div class="validation-error" *ngIf="(profileFormSubmitted || profileForm.controls['gender'].dirty) && !profileForm.controls['gender'].valid">
                <div class="form-hint">
                  <div>{{locale.genderValidationText}}</div>
                </div>
              </div>
            </div>
            <div class="form-control">
              <label for="country">{{locale.countryPlaceholder}}</label>
              <select (click)="onClickProfileInput()" id="country" class="input-control select-control" [formControl]="profileForm.controls['country']">
                  <ng-container *ngFor="let country of countryOptions; index as i; ">
                      <ng-container *ngIf="i">
                          <ng-container *ngIf="countryOptions[i-1].priority != countryOptions[i].priority">
                              <option disabled>{{locale.comboSeparator}}</option>
                          </ng-container>
                      </ng-container>
                      <option [value]="country.countryId">{{country.countryName}}</option>
                  </ng-container>

              </select>


              <span class="caret"></span>
            </div>
            <div class="form-control">
              <label for="displayLanguage">{{locale.displayLanguagePlaceholder}}</label>
              <select (click)="onClickProfileInput()" (change)="updateLanguageChanged()" id="displayLanguage" class="input-control select-control" [formControl]="profileForm.controls['displayLanguage']">
                <option *ngFor="let item of displayLanguageOptions" [value]="item.id">{{item.language}}</option>
              </select>
              <span class="caret"></span>
            </div>
            <div class="form-control">
              <label for="school">{{locale.schoolPlaceholder}}</label>
              <input (click)="onClickProfileInput()" id="school" type="text" class="input-control" [formControl]="profileForm.controls['school']"/>
            </div>
            <div class="form-control">
                <div class="input-control check-control" [class.checked]="profileForm.controls['emailPreference'].value">
                    <input (click)="onClickProfileInput()" type="checkbox" [formControl]="profileForm.controls['emailPreference']">
                </div>
                <p>{{locale.contactInputText}}</p>
            </div>
            <div *ngIf="messageCopyProfile" class="{{ messageClassProfile }}" role="errorMessage">{{ messageCopyProfile }}</div>
            <div class="form-control">
              <input type="submit" value="{{locale.saveChangesButtonText}}" class="input-control button" [disabled]="formSubmitted"/>
            </div>
          </form>

            <!-- Change Password Form -->
            <!-- Shared base manage password template -->
            <div class="column">
              <app-base-manage-password [templateSettings]="templateSettings"></app-base-manage-password>

              <h2 class="legend gdpr-header">{{ locale.gdprHeader }}</h2>
              <div class="form-control">
              <p class="gdpr-title">{{ locale.howInformation }}</p>
              <p class="gdpr-body">{{ locale.howText }} <a href="https://www.myfuturechoice.com/privacy-policy-for-students" target="_blank">{{ locale.howLink }}</a>.</p>
              </div>

              <div class="form-control">
              <p class="gdpr-title">{{ locale.downloadInformation }}</p>
              <p class="gdpr-body">{{ locale.downloadText1 }} <a routerLink="/account/right-of-access">{{ locale.downloadLink}}</a> {{ locale.downloadText2 }}</p>

              </div>

              <div class="form-control">
              <p class="gdpr-title">{{ locale.deleteInformation }}</p>
              <p class="gdpr-body">{{ locale.deleteText1 }} <a routerLink="/account/right-to-erasure">{{ locale.deleteLink }}</a> {{ locale.deleteText2 }}</p>
              </div>


            </div>

        </div>
      </div>

      <footer id="scrn-f">
        <div class="cancel">
          <a (click)="goBack()">{{locale.backLinkText}}</a>
        </div>
      </footer>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/account/settings/account-settings.component.html